// Numéro FFD d'un club. Un club créé sans numéro (affiliation en cours, ou numéro pas
// encore communiqué par la FFD) porte un provisoire NÉGATIF côté backend, jamais
// confondable avec un vrai numéro (cf. backend clubs/numbering.py, et le même utilitaire
// côté LSEF : utils/clubNumber.ts). Ce provisoire ne doit jamais être affiché tel quel.

export function isClubNumberPending(number: number | null | undefined): boolean {
  return number == null || number <= 0;
}

export function formatClubNumber(number: number | null | undefined): string {
  return isClubNumberPending(number) ? 'En attente' : String(number);
}
